import { render, staticRenderFns } from "./v-infoicon.vue?vue&type=template&id=8b7cddb2&scoped=true&"
import script from "./v-infoicon.vue?vue&type=script&lang=js&"
export * from "./v-infoicon.vue?vue&type=script&lang=js&"
import style0 from "./v-infoicon.vue?vue&type=style&index=0&id=8b7cddb2&prod&scoped=true&lang=scss&"
import style1 from "./v-infoicon.vue?vue&type=style&index=1&id=8b7cddb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7cddb2",
  null
  
)

export default component.exports